export var ACCEPT_RETENTION_WITH_BONUS = 'accept_retention_with_bonus';
export var REFUSE_RETENTION = 'refuse_retention';